/**
 * PushTokenReconciler Component
 *
 * Mounts the silent FCM token reconciliation hook once for the authenticated
 * app. Renders nothing. Must be placed inside AuthProvider so the current user
 * is available.
 */

"use client";

import { useFcmTokenReconciliation } from "@/hooks/useFcmTokenReconciliation";

export function PushTokenReconciler() {
  useFcmTokenReconciliation();
  return null;
}
